module.exports = __webpack_public_path__ + "img/vi-box4-text-dark.abde4bf1.png";